import gql from "graphql-tag";

export const FETCH_PLAYERS_QUERY = gql`
  query GetPlayers {
    getPlayers {
      name
      org
      pos
      fv
      top100
      age
      eta
      playerId
    }
  }
`;

export const FETCH_PROSPECTS_QUERY = gql`
  query GetProspects {
    getProspects {
      name
      pos
      team
      age
      bp
      fg
      p361
      mlb
      fantrax
      plive
      rotob
      # razz
      cbs
      fanpros
      #   fantasysixpack
    }
  }
`;

export const FETCH_WATCH_TEAM_QUERY = gql`
  query GetWatchlist {
    getWatchlist {
      id
      user
      name
      org
      pos
      fangraphs
    }
  }
`;
export const FETCH_TEAM_QUERY = gql`
  query GetTeam {
    getTeam {
      id
      user
      name
      org
      pos
      salary
      contract
    }
  }
`;
export const FETCH_FARM_SYSTEM_QUERY = gql`
  query GetFarmSystem {
    getFarmSystem {
      id
      user
      name
      org
      pos
      fv
      fangraphs
    }
  }
`;

export const ADD_PLAYER = gql`
  mutation addPlayer(
    $name: String!
    $pos: String!
    $org: String!
    $salary: String!
    $contract: String!
  ) {
    addPlayer(
      playerInput: {
        name: $name
        pos: $pos
        org: $org
        salary: $salary
        contract: $contract
      }
    ) {
      id
      pos
      name
      org
      salary
      contract
    }
  }
`;

export const ADD_WATCH_PLAYER = gql`
  mutation addWatchPlayer(
    $name: String!
    $pos: String!
    $org: String!
    $fangraphs: String!
  ) {
    addWatchPlayer(
      watchPlayerInput: {
        name: $name
        pos: $pos
        org: $org
        fangraphs: $fangraphs
      }
    ) {
      id
      pos
      name
      org
      fangraphs
    }
  }
`;
export const ADD_FARM_SYSTEM_PLAYER = gql`
  mutation addFarmSystemPlayer(
    $name: String!
    $pos: String!
    $org: String!
    $fv: String!
    $fangraphs: String!
  ) {
    addFarmSystemPlayer(
      farmSystemPlayerInput: {
        name: $name
        pos: $pos
        org: $org
        fv: $fv
        fangraphs: $fangraphs
      }
    ) {
      id
      pos
      name
      org
      fv
      fangraphs
    }
  }
`;
